module.exports = "/images/screen.svg?879ae680dc152cb03ecdba3866485fc7";